"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantityInput = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = require("../Button/Button");
const Link_1 = require("../Typography/Link");
const PlusBigIcon_1 = require("../icons/PlusBig/PlusBigIcon");
const BinIcon_1 = require("../icons/Bin/BinIcon");
const MinusBig_1 = require("../icons/MinusBig/MinusBig");
const QuantityInput = ({ increaseQuantity, decreaseQuantity, deleteItem, step = 1, full = false, quantity, min = 0, max = Infinity, dataTestId = '', }) => {
    const haveDeleteButton = quantity === step && deleteItem;
    return (react_1.default.createElement(CartQuantityModifierWrapper, { full: full, "data-test": "quantityInput", "data-test-id": dataTestId, "data-test-value": quantity },
        haveDeleteButton ? ( // Separate condition for icon replacement
        react_1.default.createElement(Button_1.Button, { variant: "primary", icon: react_1.default.createElement(BinIcon_1.BinIcon, null), onClick: () => {
                deleteItem();
            }, disabled: quantity <= min, dataTestId: "deleteItem" })) : (react_1.default.createElement(Button_1.Button, { variant: "primary", icon: react_1.default.createElement(MinusBig_1.MinusBigIcon, null), onClick: decreaseQuantity, disabled: quantity <= min, dataTestId: "decreaseQuantity" })),
        react_1.default.createElement(Link_1.LinkS, { className: "text-center" }, quantity),
        react_1.default.createElement(Button_1.Button, { variant: "primary", icon: react_1.default.createElement(PlusBigIcon_1.PlusBigIcon, null), onClick: increaseQuantity, disabled: quantity >= max, dataTestId: "increaseQuantity" })));
};
exports.QuantityInput = QuantityInput;
const CartQuantityModifierWrapper = styled_components_1.default.div `
    gap: 15px;
    padding: 1px;
    display: ${({ full }) => (full ? 'grid' : 'inline-grid')};
    grid-template-columns: auto 1fr auto;
    border: 1px solid #e8e8e8;
    background-color: #fff;
    border-radius: 20px;
    align-items: center;
`;
